import Vue from 'vue'
import investor from '../../api/investor'
import VueCookie from 'vue-cookie'
import localStorageHelper from '@/helpers/localStorageHelper'

const state = () => ({
  investor: null,
  already_exists_message: ''
})

// getters
const getters = {
  getOption: (state) => (option) =>
  {
    if (!state.investor)
    {
      return null
    }
    try
    {
      if (state.investor && typeof state.investor[option] !== 'undefined')
      {
        return state.investor[option]
      }
      else
      {
        console.log('ERROR to get key: ', option)
      }
    }
    catch (e)
    {
      console.log('Investor data get failed', e)
      return null
    }
  }
}

// actions
const actions = {
  updateInvestor({state, commit}, details)
  {
    commit('updateInvestor', details)
  },
  fetchUserInvestor({state, commit})
  {
    try
    {
      if (!state.investor)
      {
        investor.getInvestor().then(response =>
          {
            const mauticId = VueCookie.get('mtc_id')
            const mauticDeviceId = VueCookie.get('mautic_device_id')
            const investorId = VueCookie.get('investor_id')

            if (response.investor_id) {
              if (!investorId || investorId !== response.investor_id) {
                VueCookie.set('investor_id', response.investor_id)
              }
              if (response.investor_is_company && response.investor_is_company === 1 && response.investor_comp_name)
              {
                localStorageHelper.set('profileName', response.investor_comp_name)
              } else {
                localStorageHelper.set('profileName', response.investor_first_name + ' ' + response.investor_last_name)
              }
            }
            if (mauticId && (!response.investor_mautic_id || mauticDeviceId !== response.investor_mautic_tracking_id))
            {
              investor.update(
                {
                  mautic_id: mauticId,
                  mautic_device_id: mauticDeviceId
                }).then().catch((error) =>
              {
                console.error('Error in updating mautic id ', error)
              })
            }
            commit('updateInvestor', response)

            // Remove utm tags and referrer url from localstorage
            if (response.investor_mediasource) {
              // console.log('Found investor_mediasource remove utm_tags & referrerUrl from LS!')
              // localStorageHelper.remove('utm_tags')
              localStorageHelper.remove('referrerUrl')
            }
          }
        ).catch((error) =>
        {
          if (error.response && error.response.status && error.response.status === 401 && error.response.data && error.response.data.message)
          {
            state.already_exists_message = error.response.data.message
          }
        })
      }
    }
    catch (e)
    {
      console.log('Failed load investor', e)
    }
  }
}

// mutations
const mutations = {
  updateInvestor(state, investorData)
  {
    Vue.set(state, 'investor', investorData)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
